export default __webpack_public_path__ + "static/media/MODBUS.ef6df5b0.png";